module.exports = __webpack_public_path__ + "img/happytogether.c68b4843.jpg";